import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  InputGroup,
  Input,
  Select,
  FormGroup
} from 'reactstrap'

class FieldSelect extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedField: this.props.cardField.fieldValue
    }

    this.returnValue = this.returnValue.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
  }

  returnValue() {
    return this.state.selectedField || this[this.props.cardField.id].value
  }

  handleSelectChange(ev) {
    this.setState({
      selectedField: ev.target.value
    })
  }

  render() {
    const fieldClassName = `card-field field-select ${this.props.cardField.fieldClassName ? this.props.cardField.fieldClassName : ''}`

    return (this.props.isEditing || this.props.cardType === 'always-on') && !this.props.cardField.fieldIsDisabled ? <div className={fieldClassName}>
      <Label className="d-sm-block">{this.props.cardField.fieldLabel}</Label>
      <Input
        type={this.props.cardField.fieldType}
        name={this.props.cardField.id}
        onChange={this.handleSelectChange}
        innerRef={el => { this[this.props.cardField.id] = el }}
        defaultValue={this.props.cardField.fieldValue}
        className="mb-3 d-sm-block">
        {this.props.cardField.fieldValues.map(selectOption => {
          return <option key={selectOption.id} value={selectOption.id}>{selectOption.value}</option>
        })}
        </Input>
    </div> : <div className={fieldClassName}>
      <Label key={`label-${this.props.cardField.id}`} className="mb-0" for={this.props.cardField.id}>{this.props.cardField.fieldLabel}</Label>
      {this.props.cardField.fieldValues
        .filter(el => el.id === this.props.cardField.fieldValue)
        .map(selectOption => {
          return <div key={`select-${this.props.cardField.id}`} className="mb-3">{selectOption.value}</div>
        })
      }
    </div>
  }
}

FieldSelect.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldSelect.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldSelect


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldSelect.js